import { useEffect, useState } from 'react';

import { get } from 'ravenjs/utils/lodash';

export function useEHSProducts({ userId, fetchEHSProducts, open }) {
    const [data, setData] = useState({ skus: [], packages: [] });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        async function fetchData() {
            try {
                setLoading(true);
                const response = await fetchEHSProducts(userId);
                const ehsProduct = get(response, 'ehsProduct', {});
                const skus = get(ehsProduct, 'activeSkus', []);
                const packages = get(ehsProduct, 'activePackages', []);
                setData({ skus, packages });
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        }
        if (open) {
            fetchData();
        }
    }, [fetchEHSProducts, open, userId]);

    return { skus: data.skus, packages: data.packages, error, loading };
}
